export default __webpack_public_path__ + "static/media/ar_logo_white.02bb77a6.svg";